<!-- Bootstarp Responsive -->
<!-- <section class="vh-100 bg-image"
  style="background: url('vehicle-images/anpr-image.jpg') no-repeat center center;background-size: cover;">
  <div class="mask d-flex align-items-center h-100">
    <div class="container h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-9 col-lg-7 col-xl-6">
          <div class="card" style="border-radius: 15px;">
            <div class="card-body p-4">
              <div>
                <h2 class="text-uppercase text-center mb-3">Create an account</h2>
              </div>
              <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <input type="text" id="firstName" class="form-control" formControlName="firstName" placeholder=" " required>
                  <label for="firstName" class="form-label">First Name*</label>
                  <div  class="error" *ngIf="signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched">
                    <small *ngIf="signupForm.get('firstName')?.errors?.['required']">First Name is required.</small>
                  </div>
                </div>
                <div class="form-group">
                    <input type="text" id="lastName" class="form-control" formControlName="lastName" placeholder=" " required>
                    <label for="lastName" class="form-label">Last Name</label>
                </div>

                <div class="form-group">
                    <input type="text" id="email" class="form-control" formControlName="email" placeholder=" " required>
                    <label for="email" class="form-label">Email*</label>
                    <div  class="error" *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
                      <small *ngIf="signupForm.get('email')?.errors?.['required']">Email is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <input type="number" id="mobileNumber" class="form-control" formControlName="mobileNumber" placeholder=" "  maxlength="10" required>
                    <label for="mobileNumber" class="form-label">Mobile Number*</label>
                    <div  class="error" *ngIf="signupForm.get('mobileNumber')?.invalid && signupForm.get('mobileNumber')?.touched">
                      <small *ngIf="signupForm.get('mobileNumber')?.errors?.['required']">Mobile Number is required.</small>
                      <small *ngIf="signupForm.get('mobileNumber')?.errors?.['minlength']">Mobile Number Should be Minimum 10 characters.</small>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" id="password" class="form-control" formControlName="password" placeholder=" " required>
                    <label for="password" class="form-label">Password*</label>
                    <div  class="error" *ngIf="signupForm.get('password')?.invalid && signupForm.get('password')?.touched">
                      <small *ngIf="signupForm.get('password')?.errors?.['required']">Password is required.</small>
                      <small *ngIf="signupForm.get('password')?.errors?.['minlength']">Password Should be Minimum 8 characters.</small>
                    </div>
                </div>
                <div class="form-group">
                  <input type="text" id="confirmPassword" class="form-control" formControlName="confirmPassword" placeholder=" " required>
                  <label for="confirmPassword" class="form-label">Confirm Password*</label>
                  <div  class="error" *ngIf="signupForm.get('confirmPassword')?.invalid && signupForm.get('confirmPassword')?.touched">
                    <small *ngIf="signupForm.get('confirmPassword')?.errors?.['required']">Confirm Password is required.</small>
                    <small *ngIf="signupForm.get('confirmPassword')?.errors?.['minlength']">Confirm Password Should be Minimum 8 characters.</small>
                  </div>
              </div>

                <div class="form-check d-flex justify-content-left mb-3">
                  <input class="form-check-input me-2" type="checkbox" value="" id="form2Example3cg" />
                  <label class="form-check-label" for="form2Example3g">
                    I agree all statements in <a href="#"  class="text-decoration-none">Terms of service</a>
                  </label>
                </div>

                <div class="d-flex justify-content-left">
                  <button  type="submit" 
                    class="btn btn-success btn-lg">Register</button>
                </div>

                <p class="text-left text-muted mt-3 mb-0">Have already an account? <a href="login"
                    class="text-decoration-none">Login here</a></p>

              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->


<div class="vehicle-wrapper">
  <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
      <div class="top-header">
          <h3>{{ isDemoStaff ? 'Add Demo Staff' : 'Add Staff' }}</h3>
          <p>{{ isDemoStaff ? 'Create a read-only demo account for the selected organization.' : 'Please fill the
              required field.' }}</p>
      </div>
      <div class="form-row">
        <div class="form-item">
            <label for="userName">User Name <small>*</small></label>
            <input type="text" id="userName" formControlName="userName" required />
            <div  class="error" *ngIf="signupForm.get('userName')?.invalid && signupForm.get('userName')?.touched">
              <small *ngIf="signupForm.get('userName')?.errors?.['required']">User Name is required.</small>
            </div>
        </div>
        <div class="form-item">
          <label for="email">Email <small>*</small></label>
          <input type="email" id="email" formControlName="email" required />
          <div  class="error" *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
            <small *ngIf="signupForm.get('email')?.errors?.['required']">Email is required.</small>
          </div>
        </div>
    <!-- </div> -->
      <!-- <div class="form-row"> -->
          <div class="form-item">
              <label for="firstName">First Name <small>*</small></label>
              <input type="text" id="firstName" formControlName="firstName" required />
              <div  class="error" *ngIf="signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched">
                <small *ngIf="signupForm.get('firstName')?.errors?.['required']">First Name is required.</small>
          
              </div>
          </div>
          <div class="form-item">
            <label for="lastName">Last Name</label>
            <input type="text" id="lastName" formControlName="lastName" />
          </div>
      <!-- </div> -->
      <!-- <div class="form-row"> -->
          <div class="form-item">
            <label for="groups">Role <small>*</small></label>
              <select formControlName="groups" id="groups" [disabled]="isDemoStaff">
              <option *ngFor="let option of group | keyvalue" [value]="option.value">{{ option.value }}</option>
            </select>
            <div  class="error" *ngIf="signupForm.get('groups')?.invalid && signupForm.get('groups')?.touched">
              <small *ngIf="signupForm.get('groups')?.errors?.['required']">Role is required.</small>
            </div>
          </div>
          <div class="form-item" *ngIf="isDemoStaff">
              <label for="demoExpiryDays">Expiry Days <small>*</small></label>
              <select id="demoExpiryDays" [(ngModel)]="demoExpiryDays" [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let days of demoExpiryOptions" [value]="days">{{ days }} Days</option>
              </select>
          </div>
          <div class="form-item" *ngIf="(isPlatformSuperuser || isDemoStaff) && !isSalesManagerRole">
            <label for="organization">Organization <small>*</small></label>
              <select formControlName="organization" id="organization" (change)="onCustomerOrganizationChange()">
              <option *ngFor="let option of organization | keyvalue" [value]="option.value">{{ option.value }}</option>
            </select>
            <div  class="error" *ngIf="signupForm.get('organization')?.invalid && signupForm.get('organization')?.touched">
              <small *ngIf="signupForm.get('organization')?.errors?.['required']">Organization is required.</small>
            </div>
          </div>
          <div class="form-item" *ngIf="isPlatformSuperuser && isSalesManagerRole">
              <label for="internalOrganization">Organization <small>*</small></label>
              <input
                      id="internalOrganization"
                      type="text"
                      formControlName="organization"
                      [attr.placeholder]="internalOrgLookupStatus === 'loading' ? 'Loading organization…' : ''"
                      readonly
              />
              <small class="org-assigned-hint" *ngIf="internalOrgLookupStatus === 'loaded'">
                  Assigned to your organization
              </small>
              <small class="org-assigned-hint" *ngIf="internalOrgLookupStatus === 'loading'">
                  Loading your organization…
              </small>
              <div class="error"
                   *ngIf="internalOrgLookupStatus === 'failed' || internalOrgLookupStatus === 'missing_org_id'">
                  <small>{{ internalOrgLookupError }}</small>
                  <button
                          type="button"
                          id="retryInternalOrganization"
                          class="btn-cancel"
                          (click)="retryInternalOrganizationLookup()">
                      Retry
                  </button>
              </div>
          </div>
          <div class="form-item" *ngIf="!isPlatformSuperuser && !isDemoStaff">
              <label for="assignedOrganization">Organization <small>*</small></label>
              <input
                      id="assignedOrganization"
                      type="text"
                      [value]="assignedOrganizationName"
                      readonly
              />
              <small class="org-assigned-hint">Assigned automatically</small>
          </div>
      <!-- </div> -->
      <!-- <div class="form-row">
        <div class="form-item">
          <label for="password">New Password (Min 8 Characters)*</label>
          <input type="password" id="password" formControlName="password" required />
          <div  class="error" *ngIf="signupForm.get('password')?.invalid && signupForm.get('password')?.touched">
            <small *ngIf="signupForm.get('password')?.errors?.['required']">Password is required.</small>
            <small *ngIf="signupForm.get('password')?.errors?.['minlength']">New Password Should be Minimum 8 characters.</small>
          </div>
        </div>
        <div class="form-item">
          <label for="confirmPassword">Confirm Password (Min 8 Characters)**</label>
          <div class="eye-visiblie">
              <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="confirmPassword" id="confirmPassword" required />
              <div (click)="togglePasswordVisibility()">
                <fa-icon [icon]="isPasswordVisible ? ['fas', 'eye'] : ['fas', 'eye-slash']" class="fa-thin"></fa-icon>
              </div>
          </div>
          <div  class="error" *ngIf="signupForm.get('confirmPassword')?.invalid && signupForm.get('confirmPassword')?.touched">
            <small *ngIf="signupForm.get('confirmPassword')?.errors?.['required']">Confirm Password is required.</small>
            <small *ngIf="signupForm.get('confirmPassword')?.errors?.['minlength']">Confirm Password Should be Minimum 8 characters.</small>

          </div>
        </div>
      </div> -->
      <!-- <div class="form-row"> -->
        <div class="form-item">
          <label for="mobileNumber">Phone Number (Min 10 & Max 14 Characters) <small>*</small></label>
          <input type="text" id="mobileNumber" formControlName="mobileNumber" required />
          <div  class="error" *ngIf="signupForm.get('mobileNumber')?.invalid && signupForm.get('mobileNumber')?.touched">
            <small *ngIf="signupForm.get('mobileNumber')?.errors?.['required']">Phone Number is required.</small>
            <small *ngIf="signupForm.get('mobileNumber')?.errors?.['minlength']">Phone Number Should be Minimum 10 characters.</small>
          </div>
        </div>
      </div>
      <!-- <div class="check">
          <input type="checkbox" id="terms"  required />
          <label class="form-check-label" for="terms">
            I agree all statements in <a href="login">Terms of service</a>
          </label>
      </div> -->
      <div class="button-row">
          <button type="submit"
          class="btn-save"
                  id="signupSubmit"
                  [disabled]="isSalesManagerSubmitBlocked"
          >
              <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon> ADD
              <!-- <app-spinner 
              *ngIf="loadingservice.isLoading('signup')"
              size="small"
              >
                
              </app-spinner> -->
          </button>
          <button type="button" class="btn-cancel" (click)="onCancel()">
            <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> Cancel
        </button>
      </div>
  </form>
</div> 